import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";

import maintenance from "../../assets/images/maintenance.gif"
import emoji from "../../assets/images/emoji.gif"
import shop from "../../assets/images/24h-shop.gif"
import smartphone from "../../assets/images/smartphone.gif"

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  margin-top: 16px;

  @media (max-width: 768px) {
    display: grid;
  }
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  margin: 0px;
  color: #ffffff;

  span {
    color: #4162fd;
  }
`;

const InfoCard = styled.div`
  display: flex;
  align-items: center;
  padding: 40px;
  border-radius: 14px;
  background-color: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  height: 80px;
`;

const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  margin-right: 24px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
`;

const TitleCard = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #000;
`;

const SubtitleCard = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #000;
  margin-top: 4px;
`;

const Whatsapp = () => {
  return (
    <Container
      style={{ textAlign: "center", background: "#000000",}}
      id="section-5"
    >
      <br />
      <br />
      <Header>
        <Title>
          Porque usar o <span style={{ color: "#E4DA1B" }}>Alfred?</span>
        </Title>
      </Header>
      <Row
        xs="1fr"
        sm="1fr"
        md="1fr 1fr"
        lg="1fr 1fr"
        xl="1fr 1fr"
        style={{ marginTop: "80px", alignItems: "center" }}
      >
          <InfoCard>
            <IconWrapper>
              <img src={shop} alt="Icon" />
            </IconWrapper>
            <TextContent>
              <TitleCard>Sempre disponível</TitleCard>
              <SubtitleCard>
                Atende seus clientes 24 horas por dia, sem perder nenhuma
                oportunidade.
              </SubtitleCard>
            </TextContent>
          </InfoCard>
          <InfoCard>
            <IconWrapper>
              <img src={emoji} alt="Icon" />
            </IconWrapper>
            <TextContent>
              <TitleCard>Do seu jeito</TitleCard>
              <SubtitleCard>
                Você treina o Alfred com a base de conhecimento do seu negócio —
                ele fala como você falaria.
              </SubtitleCard>
            </TextContent>
          </InfoCard>
          <InfoCard>
            <IconWrapper>
              <img src={maintenance} alt="Icon" />
            </IconWrapper>
            <TextContent>
              <TitleCard>Fácil de colocar pra rodar</TitleCard>
              <SubtitleCard>
                Em minutos seu WhatsApp já está integrado, sem precisar de
                programação.{" "}
              </SubtitleCard>
            </TextContent>
          </InfoCard>
          <InfoCard>
            <IconWrapper>
              <img src={smartphone} alt="Icon" />
            </IconWrapper>
            <TextContent>
              <TitleCard>Tudo acontece no WhatsApp</TitleCard>
              <SubtitleCard>
                A plataforma mais usada pelos brasileiros agora trabalha a seu
                favor.
              </SubtitleCard>
            </TextContent>
          </InfoCard>
      </Row>
    </Container>
  );
};

export default Whatsapp;
